import { useSettingsStore } from '../../store/settingsStore';

/**
 * Behind the Home menu: the painted battlefield poster under a readability scrim (styles.css).
 * Options → Menu background: `static` stops the drift, `off` leaves only the dark base colour.
 */
export function HomeBackdrop() {
  const menuBackground = useSettingsStore((s) => s.menuBackground);
  return (
    <div className="home-backdrop" data-bg={menuBackground} aria-hidden="true">
      {menuBackground !== 'off' && <div className="home-poster" />}
    </div>
  );
}
